<template>
  <div class="distribute_analyze">
    <div class="title">
      <div class="search_box" @click="checkArea('appoinment')">
        <span class="select-area">{{ appoinmentType.text }}</span>
        <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
      </div>
      <div class="search_box" @click="checkArea('area')" v-if="localNum !== 3">
        <span class="select-area">{{selectArea}}</span>
        <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
      </div>
      <div class="search_box" v-else>
        <span class="select-area">{{selectArea}}</span>
      </div>
      <div class="search_box" @click="showRangTimeTop">
        <span class="select-area">{{selectTime}}</span>
        <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
      </div>
    </div>
    <!-- 州市预约情况 -->
    <div v-if="provinAuth==1" class="title_mode first_title">州市预约情况</div>
    <div v-if="provinAuth==1" class="histogram">
      <mulColumnCharts
        v-if="cityColumnList.length>0 && appoinmentType.val === 2"
        :columnData="cityColumnList"
        :dimensions="dimensions"
        :colors="colors"
        :unit="unit"
        :showName="false"
      ></mulColumnCharts>
      <doubleColumnCharts
        v-if="cityColumnList.length>0 && appoinmentType.val === 1"
        :columnData="cityColumnList"
        :dimensions="dimensions"
        :colors="colors"
        :unit="unit"
        :showName="false"
      ></doubleColumnCharts>
       <singleColumnChart
        v-if="cityColumnList.length>0 && appoinmentType.val === 3"
        :columnData="cityColumnList"
        :dimensions="dimensions"
        :colors="colors"
        :unit="unit"
        :showName="false"
      ></singleColumnChart>
    </div>
    <!-- 景区预约情况 -->
    <div class="top title_mode">
      <span class="tit">景区预约情况</span>
      <span v-if="appoinmentType && appoinmentType.val === 2" class="desc">(符合奖补景区Top 10)</span>
    </div>
    <div>
      <div class="histogram" v-if="columnList.length>0">
        <mulColumnCharts
          v-if="columnList.length>0 && appoinmentType.val === 2"
          :columnData="columnList"
          :dimensions="dimensions"
          :colors="colors"
          :unit="unit"
          :showName="true"
        ></mulColumnCharts>
        <doubleColumnCharts
        v-if="columnList.length>0 && appoinmentType.val === 1"
        :columnData="columnList"
        :dimensions="dimensions"
        :colors="colors"
        :unit="unit"
        :showName="true"
      ></doubleColumnCharts>
      <singleColumnChart
        v-if="columnList.length>0 && appoinmentType.val === 3"
        :columnData="columnList"
        :dimensions="dimensions"
        :colors="colors"
        :unit="unit"
        :showName="true"
      ></singleColumnChart>
      </div>
      <div class="noScenicList" v-else>
        <div class="noScenic">
          <div class="noScenicItem">
            <div class="noScenicItemImg">
              <img src="../../../../../assets/appointment/ic_wuxingxi@3x.png" alt />
            </div>
            <div class="noScenicItemContent">无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="appoinmentType && appoinmentType.val !== 3" class="foot">
      <div class="top">
        <span class="tit">旅行社预约情况</span>
        <span class="desc">(预约所选行政区内景区的Top 10)</span>
      </div>
      <div v-if="travelMsg.length" class="ScenicList">
        <div class="counts" v-for="item in travelMsg" :key="item.travelAgentId">
          <div class="describe">
            <div class="tip">{{ item.travelAgentName }}</div>
            <div class="content">
              <div class="item">
                <div class="item_top">预约人数(人)</div>
                <div class="count">{{ item.appointPeopleNum|numSeparate }}</div>
              </div>
              <div class="item">
                <div class="item_top">入园人数(人)</div>
                <div class="count">{{ item.inParkNum|numSeparate }}</div>
              </div>
              <div v-if="appoinmentType.val === 2" class="item">
                <div class="item_top">奖补人数(人)</div>
                <div class="count">{{ item.subsidyNum|numSeparate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noScenicList" v-else>
        <div class="noScenic">
          <div class="noScenicItem">
            <div class="noScenicItemImg">
              <img src="../../../../../assets/appointment/ic_wuxingxi@3x.png" alt />
            </div>
            <div class="noScenicItemContent">无数据</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 预约 -->
    <common-picker
      ref="appoinmentPicker"
      :typeList="appoinmentTypeList"
      :cols="1"
      @getTypeValue="getAppoinmentTypeValue"
    ></common-picker>
    <!-- 区域 -->
    <common-picker
      ref="areaPicker"
      :typeList="typeListCity"
      :cols="colsCity"
      @getTypeValue="getCityValue"
    ></common-picker>
    <!-- 年月日弹窗 -->
    <!-- <common-picker ref="commonPicker2" :typeList="typeListTime" :cols="colsTime" @getTypeValue="getValue" :isShowAbountButton="isShowAbountButton" @showRangTime="showRangTime"></common-picker> -->
    <!-- 日历 -->
    <rangTime ref="rangeTime" @getCurrentTime="getCurrentTime" :allowSameDay="true" ></rangTime>
    <!-- 奖补限制时间选择器 -->
    <rangTime ref="rangeTime2" @getCurrentTime="getCurrentTime" :allowSameDay="true" :minDate="minDate" :maxDate="maxDate"></rangTime>
  </div>
</template>

<script>
import appointment from "../../../../../service/modules/appointment";
import mulColumnCharts from "@/components/mulColumnCharts";
import doubleColumnCharts from "@/components/doubleColumnCharts"
import singleColumnChart from "@/components/singleColumnChart"
import commonPicker from "../../../../components/base/commonPicker";
import rangTime from "../../../components/rangTime";
import { timeType1, appoinmentTime } from "../../../../../utils/configJson";
export default {
  components: {
    mulColumnCharts,
    commonPicker,
    rangTime,
    doubleColumnCharts,
    singleColumnChart
  },
  data() {
    return {
      subsidyDate: {
        beginTime: '2020-05-22',
        endTime: '2020-12-31'
      },
      minDate: new Date('2020/5/22'),
      maxDate: new Date('2020/12/31'),
      colsAppoiment: 1,
      isShowAbountButton: true,
      areaCode: JSON.parse(localStorage.getItem("auth")).areaCode,
      /** areaLevel  1省,2市,3区县 */
      localNum: JSON.parse(localStorage.getItem("auth")).areaLevel,
      chartsData: [],
      color: "green",
      unit: "人",
      columnList: [],
      dimensions: ["product", "预约人数", "入园人数", "奖补人数"],
      cityColumnList: [],
      colors: [],
      columX: [],
      selectArea: "", // 当前选中的地区
      selectTime: "选择时间", // 当前选中的时间
      typeListCity: timeType1,
      colsCity: 0 /** 区域 */,
      typeListTime: appoinmentTime,
      colsTime: 3 /** 时间 */,
      // minDate:  new Date('2020/12/12'),
      beginTime: "",
      endTime: "",
      cityScenicAppoint: {}, // 州市预约情况
      travelMsg: [], // 旅行社预约情况
      provinAuth: JSON.parse(localStorage.getItem("auth")).areaLevel,
      appoinmentType: {
        text: "团队预约(全部)",
        val: 1 // 1：团队预约全部  2：团队预约(奖补)  3：散客预约
      }, // 选择的预约类型，根据该对象进行有关判断，像echart显示几列
      appoinmentTypeList: [
        [
          {
            text: "团队预约(全部)",
            val: 1
          },
          {
            text: "团队预约(奖补)",
            val: 2
          },
          {
            text: "散客预约",
            val: 3
          }
        ]
      ] // 预约类型：团队预约(全部)、团队预约(奖补)、散客预约
    };
  },
  methods: {
    // 选择预约类型回调：团队预约、散客预约
    getAppoinmentTypeValue(value) {
      if (value[0].val == 2) {
        this.beginTime = this.subsidyDate.beginTime;
        this.endTime = this.subsidyDate.endTime;
        this.selectTime = (this.beginTime + "~" + this.endTime).replace(/-/g, '/')
      } else {
        this.beginTime = '';
        this.endTime = '';
        this.selectTime = '选择时间';
      }
      this.appoinmentType = value[0];
      this.queryCityScenicAppoint();
      this.queryScenicAppoint();
      if (value[0].val != 3)
      this.queryTravelAgencyAppoint();
    },
    /** 唤醒年月日弹窗 */
    showRangTimeTop() {
      // this.$refs.commonPicker2.showPicker();
      if (this.appoinmentType.val == 2) {
        this.$refs.rangeTime2.showTime();
      } else {
        this.$refs.rangeTime.showTime();
      }
    },
    /** 唤醒日历弹窗 */
    // showRangTime () {
    //     this.$refs.rangeTime.showTime();
    // },
    /** 年月日弹窗时间处理 */
    // getValue(value) {
    //   console.log(value);
    //   if (value[1].key === "year") {
    //     this.time = value[0].value;
    //     this.beginTime = value[0].value + "-" + value[1].value1;
    //     this.endTime = value[0].value + "-" + value[1].value2;
    //   } else if (value[1].key === "quarter") {
    //     this.time = value[0].value + value[2].text;
    //     this.beginTime = value[0].value + "-" + value[2].value1;
    //     this.endTime = value[0].value + "-" + value[2].value2;
    //   } else if (value[1].key === "moutn") {
    //     this.time = value[0].value + "年" + value[2].value1;
    //     const d = new Date(value[0].value, value[2].value1, 0); // 获取当月的天数
    //     this.beginTime = value[0].value + "-" + value[2].value1 + "-01";
    //     this.endTime =
    //       value[0].value + "-" + value[2].value1 + "-" + d.getDate();
    //   }
    //   this.selectTime = this.beginTime + "~" + this.endTime;
    //   this.queryCityScenicAppoint();
    //   this.queryTravelAgencyAppoint();
    //   this.queryScenicAppoint();
    // },
    /** 日历事件弹窗处理 */
    getCurrentTime(value) {
      if (value) {
        this.beginTime = value[0].split(" ")[0];
        this.endTime = value[1].split(" ")[0];
        if (this.beginTime == this.endTime) {
          this.selectTime = this.beginTime.replace(/-/g, '/');
        } else {
          this.selectTime = (this.beginTime + "~" + this.endTime).replace(/-/g, '/');
        }
        this.ishowRangeTime = false;
        this.queryCityScenicAppoint();
        this.queryTravelAgencyAppoint();
        this.queryScenicAppoint();
      } else {
        this.ishowRangeTime = false;
      }
    },
    // 获取州市预约情况
    queryCityScenicAppoint() {
      let isSubsidy = 0;
      let channelType = 0;
      switch (this.appoinmentType.val) {
        case 1:
          isSubsidy = 0;
          channelType = 1;
          break;
        case 2:
          isSubsidy = 1;
          channelType = 1;
          break;
        case 3:
          isSubsidy = 0;
          channelType = 2;
          break;
      }
      let params = {
        areaCode: this.areaCode,
        startDate: this.beginTime,
        endDate: this.endTime,
        isSubsidy: isSubsidy,
        channelType: channelType
      };
      this.cityColumnList = [];
      appointment.queryCityAppoint(params).then(res => {
        res.data.forEach(item => {
          this.cityColumnList.push({
            product: item.city.cityName,
            预约人数: ` ${item.appointPeopleNum || 0}`,
            入园人数: ` ${item.inParkNum || 0}`,
            奖补人数: ` ${item.subsidyNum || 0}`
          });
        });
        this.colors = ["#36B374", "#FF8C19", "#2283E6"];
      });
    },
    // 景区预约情况
    queryScenicAppoint() {
      let isSubsidy = 0;
      let channelType = 0;
      switch (this.appoinmentType.val) {
        case 1:
          isSubsidy = 0;
          channelType = 1;
          break;
        case 2:
          isSubsidy = 1;
          channelType = 1;
          break;
        case 3:
          isSubsidy = 0;
          channelType = 2;
          break;
      }
      let params = {
        areaCode: this.areaCode,
        startDate: this.beginTime,
        endDate: this.endTime,
        isSubsidy: isSubsidy,
        channelType: channelType
      };
      this.columnList = [];
      appointment.queryScenicAppoint(params).then(res => {
        if (res.ret === 0) {
          res.data.forEach(item => {
            this.columnList.push({
              product: item.orgName,
              预约人数: ` ${item.appointPeopleNum || 0}`,
              入园人数: ` ${item.inParkNum || 0}`,
              奖补人数: ` ${item.subsidyNum || 0}`
            });
          });
          this.colors = ["#36B374", "#FF8C19", "#2283E6"];
        }
      });
    },
    // 预约旅行社统计预约情况
    queryTravelAgencyAppoint() {
      let isSubsidy = 0;
      let channelType = 0;
      switch (this.appoinmentType.val) {
        case 1:
          isSubsidy = 0;
          channelType = 1;
          break;
        case 2:
          isSubsidy = 1;
          channelType = 1;
          break;
        case 3:
          isSubsidy = 0;
          channelType = 2;
          break;
      }
      let params = {
        areaCode: this.areaCode,
        startDate: this.beginTime,
        endDate: this.endTime,
        isSubsidy: isSubsidy,
        channelType: channelType
      };
      appointment.queryTravelAgencyAppoint(params).then(res => {
        this.travelMsg = res.data;
      });
    },
    // 选择地区回调
    getCityValue(value) {
      if (value && value.length === 2) {
        if (value[1].text === "--") {
          this.selectArea = value[0].text;
          this.areaCode = value[0].value;
        } else {
          this.selectArea = value[0].shortName + value[1].shortName;
          this.areaCode = value[1].value;
        }
      } else if (value && value.length === 1) {
        this.selectArea = value[0].text;
        this.areaCode = value[0].value;
      }
      this.queryCityScenicAppoint();
      this.queryTravelAgencyAppoint();
      this.queryScenicAppoint();
    },
    // 点击下拉选择地域
    checkArea(type) {
      if (type === "appoinment") {
        this.$refs.appoinmentPicker.showPicker();
      } else if (type === "area") {
        if (this.localNum === 1) {
          this.resetAllCity();
        }
        this.$refs.areaPicker.showPicker();
      }
    },
    resetAllCity() {
      this.typeListCity[0][0].children = [
        {
          text: "--",
          value: "",
          shortName: "",
          children: [
            {
              text: "--",
              value: "",
              shortName: "",
            }
          ]
        }
      ]
    },
    getAllCity() {
      appointment.city({ areaCode: this.areaCode }).then(res => {
        if (this.localNum === 1) {
          res.data[0].shortName = res.data[0].shortName == '云南省'? '全省': res.data[0].shortName
          res.data[0].fullName = res.data[0].fullName == '云南省'? '全省': res.data[0].fullName
          this.selectArea = res.data[0].shortName;
          this.colsCity = 2;
          let obj = {
            text: res.data[0].fullName,
            value: res.data[0].areaCode,
            shortName: res.data[0].shortName,
            children: [
              {
                text: "--",
                value: "",
                shortName: "",
              }
            ]
          };
          let arr = res.data[0].children.map(
            ({ fullName, areaCode, shortName, children }) => {
              return {
                text: shortName || fullName,
                value: areaCode,
                shortName,
                children: children
                  ? children.map(({ fullName, areaCode, shortName }) => {
                      return {
                        text: shortName || fullName,
                        value: areaCode,
                        shortName
                      };
                    })
                  : []
              };
            }
          );
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].children) {
              let cityChild = [
                { text: "--", value: "", shortName: "" }
              ];
              let newArr = arr[i].children.concat([]);
              arr[i].children = cityChild.concat(newArr);
            }
          }
          arr.unshift(obj);
          this.typeListCity = [];
          this.typeListCity.push(arr);
        } else if (this.localNum === 2) {
          this.colsCity = 2;
          this.selectArea = res.data[0].shortName;
          let brr = [];
          brr.push(res.data[0]);
          brr = brr.map(({ fullName, areaCode, shortName, children }) => {
            return {
              text: shortName || fullName,
              value: areaCode,
              shortName: shortName,
              children: children
                ? children.map(({ fullName, areaCode, shortName }) => {
                    return {
                      text: shortName || fullName,
                      value: areaCode,
                      shortName: shortName
                    };
                  })
                : []
            };
          });
          for (var j = 0; j < brr.length; j++) {
            if (brr[j].children) {
              let cityChild = [
                {
                  text: "--",
                  value1: "--",
                  regionType: ""
                }
              ];
              let newArr = brr[j].children.concat([]);
              brr[j].children = cityChild.concat(newArr);
            }
          }
          this.typeListCity = [];
          this.typeListCity.push(brr);
          console.log("brr", brr);
        } else if (this.localNum === 3) {
          this.colsCity = 1;
          this.selectArea = res.data[0].shortName;
        }
      });
    }
  },
  created() {
    this.getAllCity();
    this.queryCityScenicAppoint();
    this.queryTravelAgencyAppoint();
    this.queryScenicAppoint();
  },
  filters: {
    numSeparate(value) {
      var rag = /(\d)(?=(?:\d{3})+$)/g;
      if (!value) {
        return "0";
      } else {
        if ((value + "").indexOf('.') != -1) {
          let num = value.toString().split('.');
          return num[0].replace(rag, "$1,") + '.' + num[1];
        }
        return (value + "").replace(rag, "$1,");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.distribute_analyze {
  background-color: #fbfbfb;
  padding: 40px 12px 48px 12px;
}
.histogram {
  margin: 0 auto;
  width: 351px;
  height: 246px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
}
.histogram .title {
  width: 100%;
}
.noScenicList {
  background: #eee;
  margin: 16px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 16px 0 0 0;
  overflow: hidden;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  .noScenic {
    display: flex;
    justify-content: center;
    height: 155px;
    .noScenicItem {
      margin-top: 30px;
      .noScenicItemImg {
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
        img {
          display: inline-block;
          width: 74px;
          height: 62px;
        }
      }
      .noScenicItemContent {
        text-align: center;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
.line-chart {
  position: relative;
  margin: 15px 12px;
  display: flex;
  justify-content: center;
  width: 350px;
  height: 300px;
}
.title {
  padding: 24px 6px 24px 0;
  display: flex;
  align-items: center;
}
.search_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 4px;
  padding: 0 8px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:first-child {
    margin-left: 0;
  }
}
.search_box span {
  display: inline-block;
  padding-right: 5px;
  color: #666;
}
.search_box i {
  display: inline-block;
  width: 20px;
  height: 30px;
  line-height: 30px;
}
.search_box img {
  display: inline-block;
  width: 6px;
  height: 4px;
  vertical-align: middle;
}
.select-area {
  overflow: hidden;
  text-overflow: ellipsis;
}
.top {
  margin-top: 24px;
  .tit {
    font-size: 20px;
    color: #333;
    font-weight: bold;
  }
  .desc {
    font-size: 12px;
    color: #666;
  }
}
.foot {
  margin-bottom: 24px;

  .counts {
    margin-top: 12px;
    padding-bottom: 16px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    .describe {
      .tip {
        padding: 16px;
        height: 46px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }
      .content {
        display: flex;
        align-items: center;
      }
      .item {
        flex: 1;
        padding-left: 16px;
        .item_top {
          padding: 0 0 8px 0;
          font-size: 12px;
          color: #333;
        }
        .count {
          font-size: 20px;
          color: #36b374;
          font-weight: bold;
        }
      }
    }
  }
  .noScenicList {
    background: #eee;
    margin: 16px 0;
    background-color: #fff;
    box-sizing: border-box;
    padding: 16px 0 0 0;
    overflow: hidden;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    .noScenic {
      display: flex;
      justify-content: center;
      height: 155px;
      .noScenicItem {
        margin-top: 30px;
        .noScenicItemImg {
          margin-bottom: 24px;
          display: flex;
          justify-content: center;
          img {
            display: inline-block;
            width: 74px;
            height: 62px;
          }
        }
        .noScenicItemContent {
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}
.title_mode {
  padding: 0 12px 12px;
}
.first_title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}
</style>

<style lang="less">
.distribute_analyze {
  .van-button--round {
    border-radius: 0px;
  }
  /deep/.md-popup-mask {
    background-color: rgba(37, 38, 45, 0.3);
  }
}
</style>
